<template>
  <div>
    <el-select
      v-model="tagQuery"
      placeholder="Filtrer oste"
      filterable
      clearable
      size="small">
      <el-option
        v-for="tag in $store.getters.tags"
        :key="tag"
        :label="tag"
        :value="tag" />
    </el-select>
    <div class="card-container">
      <cheese-card
        v-for="info in $store.getters.cheeses"
        :key="info.name"
        :info="info" />
    </div>
  </div>
</template>

<script>
import CheeseCard from './CheeseCard.vue'

export default {
  components: {
    CheeseCard,
  },
  computed: {
    tagQuery: {
      get() {
        return this.$store.state.tagQuery
      },
      set(value) {
        this.$store.commit('updateTagQuery', value)
      }
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/CheeseList.vue